__webpack_require__.p = "/reports-notes-naming-event-details/referrals-hub/";